import React from "react";
import Box from "@mui/material/Box";

// Search Icon
import TextField from "@mui/material/TextField";

// Auto Complete Component
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";

const alphaWithUnderscore = (str) => str.replace(/[^\w]/g, "");

const AutoCompleteTextBox = ({ configData }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <FormControl fullWidth>
        <Autocomplete
          autoSelect
          freeSolo={configData.freeSolo}
          forcePopupIcon={true}
          placeholder={configData.placeHolder}
          options={configData.templateOptions.map((option) => option.label)}
          onSelect={(e) => {
            configData.setTemplate(e.target.value);
          }}
          onInputChange={(e) => {
            if (!configData.freeSolo) configData.setTemplate("");
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              error={configData.maxLengthValidation && !!configData.templateError}
              helperText={configData.maxLengthValidation && configData.templateError}
              inputProps={configData.maxLengthValidation ? { ...params.inputProps, maxLength: 50 } : ""}
              label={configData.label}
              value={configData.template}
              onInput={(e) => {
                if (configData.textValiation) {
                  const validValue = alphaWithUnderscore(e.target.value);
                  e.target.value = validValue;
                  configData.setTemplate(validValue);
                }
              }}
            />
          )}
        />
      </FormControl>
    </Box>
  );
};

export default AutoCompleteTextBox;
